import React from 'react';
import sheleg from '../api/sheleg';
import shelegApi from '../api/shelegApi';
import langConf from "../js/lang";
import ItemList from './ItemList';
import TopMenu from './TopMenu';
import CartItems from './CartItems';
import Payment from './Payment';
import BidItems from './BidItems';
import FinalOffer from './FinalOffer';
import BackButton from './BackButton';
import Login from './Login';
import Signup from './Signup';
import './queries.css';
import './Signup.css';
import './tblResponsiveHeb.css';
import ForgotPassword from './ForgotPassword';
import { createBrowserHistory } from 'history';
import ErrorBoundary from './ErrorBoundary';
import TransactionResult from './TransactionResult';

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            objNo: '',//this.querystring('n'), //'826639245'
            items: [],
            categories: [],
            selectedCategory: '0',
            vendorData: '',
            companyNo: '1',
            objType: '',//this.querystring('t'), //'2'
            language: 'hebrew',
            currency: 'ILS',
            currentURL: window.location.href,
            screen: 'items', //items
            slgCustId: this.querystring('v'), //'7'
            allItems: [],
            existingCartItems: [],
            spinnerMode: 'active',
            bidItems: [],
            includeBidItems: true,
            finalOfferItems: [],
            pricesIncludeVat: true,
            transactionResult: false,
            sessionId: '',
            invNo: 0,
            cities: [],
            selectedCity: '',
            selectedCityName: '',
            streets: [],
            selectedStreet: '',
            selectedStreetName: '',
            paymentMode: 'signup',//'signup',
            availablePayments: 24,
            multiplePayments: false,
            existingUsername: ''
        };
    }

    componentDidMount = async () => {

        await this.getSessionId(this.state.slgCustId);
        await this.getVendorData(this.state.companyNo);
        await this.getAvailablePayments();
        await this.getAllItems();
        await this.getCategories();
        this.selectedCategoryChanged(this.state.selectedCategory);
        localStorage.setItem('v', this.querystring('v')[0]);
        this.setState({ spinnerMode: '' });
        await this.getCities();
    }

    querystring(obj) {
        const result = [];
        let match;
        const re = new RegExp('(?:\\?|&)' + obj + '=(.*?)(?=&|$)', 'gi');
        while ((match = re.exec(document.location.search)) !== null) {
            result.push(match[1]);
        }
        return result;
    }

    NormalizeDate(day, month, year) {
        var finalDate = '';
        var finalMonth = '';
        var finalDay = '';
        if (month + 1 < 10) {
            finalMonth = '0' + (month + 1);
        }
        else {
            finalMonth = month + 1;
        }
        if (day < 10) {
            finalDay = '0' + day;
        }
        else {
            finalDay = day;
        }
        finalDate = '' + year + '-' + finalMonth + '-' + finalDay + '';
        return finalDate;
    }

    getSessionId = async () => {
        let lang = this.state.language;
        const response = await sheleg.get(`ClearingPage/${this.state.slgCustId}/sid`);
        let sessionId = response.data;
        if (sessionId === '') {
            window.alert(langConf[lang].unexpectedError);
        }
        else {
            //console.log('response: ', response);
            //console.log('sessionId: ', sessionId);
            this.setState({ sessionId: sessionId });
            localStorage.setItem('sessionId', sessionId);
        }
    };

    getAllItems = async () => {
        let arr = [];
        let today = new Date();
        const response = await sheleg.get(`ClearingPage/${this.state.slgCustId}/Items`);
        //console.log('items: ', response.data);
        await response.data.map((item) => arr.push(
            {
                itemNo: item.itemNo === null ? '' : item.itemNo,
                category: item.category === null ? '' : item.category,
                hebDescription: item.hebDescription === null ? '' : item.hebDescription,
                engDescription: item.engDescription === null ? '' : item.engDescription,
                hebName: item.hebName === null ? '' : item.hebName,
                engName: item.engName === null ? '' : item.engName,
                picDescription: item.picDescription === null ? '' : item.picDescription,
                picFile: item.picFile === null ? '' : item.picFile,
                priceNis: item.priceNIS === null ? '' : item.priceNIS,
                priceUsd: item.priceUSD === null ? '' : item.priceUSD,
                quantity: 0,
                cartNo: 0,
                recKey: 0,
                runningLineNo: 0,
                cartItemDate: today
            }
        ));
        for (let i = 0; i < arr.length; i++) {
            let itemDate = new Date(arr[i].cartItemDate);
            let year = itemDate.getFullYear();
            let month = itemDate.getMonth();
            let day = itemDate.getDate();
            arr[i].cartItemDate = this.NormalizeDate(day, month, year);
        }
        //console.log('items: ', arr);
        this.setState({ allItems: arr });
    }


    getExistingCart = async () => {
        const response = await sheleg.get(`ClearingPage/${this.state.slgCustId}/Customer/${this.state.objType}/${this.state.objNo}/cart`);
        //console.log('Existing cart: ', response);
        let invNo = 0;
        let arr = [];
        response.data.map((cartItem) => arr.push(
            {
                cartItemDate: cartItem.cartItemDate === null ? '' : cartItem.cartItemDate,
                cartNo: cartItem.cartNo === null ? '' : cartItem.cartNo,
                itemNo: cartItem.itemNo === null ? '' : cartItem.itemNo,
                itemDescription: cartItem.itemDescription === null ? '' : cartItem.itemDescription,
                priceNis: cartItem.itemNISPrice === null ? '' : cartItem.itemNISPrice,
                priceUsd: cartItem.itemUSDPrice === null ? '' : cartItem.itemUSDPrice,
                quantity: cartItem.quantity === null ? '' : cartItem.quantity,
                recKey: cartItem.recKey === null ? '' : cartItem.recKey,
                runningLineNo: cartItem.runningLineNo === null ? '' : cartItem.runningLineNo
            }
        ));
        if (arr.length > 0) {
            invNo = arr[0].cartNo;
        }
        for (let i = 0; i < arr.length; i++) {
            let itemDate = new Date(arr[i].cartItemDate);
            let year = itemDate.getFullYear();
            let month = itemDate.getMonth();
            let day = itemDate.getDate();
            arr[i].cartItemDate = this.NormalizeDate(day, month, year);
        }
        this.setState({ bidItems: arr, invNo: invNo });
    }

    getCategories = async () => {
        const response = await sheleg.get(`ClearingPage/${this.state.slgCustId}/Categories`);
        let arr = [];
        response.data.map((category) => arr.push(
            {
                classCode: category.classCode,
                hebDscrp: category.hebDscrp,
                engDscrp: category.engDscrp
            }
        ));
        arr.push({ classCode: '0', hebDscrp: langConf['hebrew'].allItems, engDscrp: langConf['english'].allItems });
        this.setState({ categories: arr });
    }

    getCities = async () => {
        //let lang = this.state.language;
        const response = await shelegApi.get(`/Cities`);
        let arr = [];
        //arr.push({ cityCode: '0', cityName: langConf[lang].selectCity });
        //console.log('cities: ', response.data);
        response.data.map((city) => arr.push(
            {
                cityCode: city.cityCode,
                cityName: city.cityName
            }
        ));
        this.setState({ cities: arr });
    }

    getStreets = async (cityCode) => {
        //let lang = this.state.language;
        //console.log('selectedCity: ', cityCode);
        if (cityCode !== '') {
            const response = await shelegApi.get(`/${cityCode}/Streets`);
            let arr = [];
            //arr.push({ streetCode: '0', streetName: langConf[lang].selectStreet });
            //console.log('streets: ', response.data);
            response.data.map((street) => arr.push(
                {
                    streetCode: street.streetCode,
                    streetName: street.streetName
                }
            ));
            this.setState({ streets: arr });
        }
    }

    getVendorData = async (companyNo) => {
        const vendorResponse = await sheleg.get(`ClearingPage/${this.state.slgCustId}/VendorData/${companyNo}`);
        //console.log('vendor response: ', vendorResponse);
        let vendorData = {
            companyNameEng: vendorResponse.data[0].companyNameEng,
            companyNameHeb: vendorResponse.data[0].companyNameHeb,
            defaultCurrency: vendorResponse.data[0].defaultCurr,
            priceIncludeVat: vendorResponse.data[0].sitepriceIncludeVat,
            logoUrlEng: vendorResponse.data[0].webLogoFileEng,
            logoUrlHeb: vendorResponse.data[0].webLogoFileHeb,
            availablePayments: vendorResponse.data[0].maxPayments
        };
        //console.log('vendorData: ', vendorData);
        this.setState(
            {
                vendorData: vendorData,
                currency: vendorData.defaultCurrency === 9999 ? 'ILS' : 'USD',
                priceIncludeVat: vendorData.priceIncludeVat !== null ? vendorData.priceIncludeVat : true,
                availablePayments: vendorData.availablePayments
            });
        this.changeVatIncluded(vendorData.priceIncludeVat);
    }

    //addToCart => get item number, loop through allItems, whenever allItems's itemNo === param itemNo add quantity for allItems's object

    addToCart = (itemNo) => {
        let arr = this.state.allItems.slice();
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].itemNo === itemNo) {
                arr[i].quantity++;
            }
        }
        this.setState({ allItems: arr });
    };

    //removeFromCart => get item number, loop through allItems, whenever allItems's itemNo === param itemNo, subtract quantity for allItems's object
    removeFromCart = (itemNo) => {
        let arr = this.state.allItems.slice();
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].itemNo === itemNo) {
                if (arr[i].quantity > 0) {
                    arr[i].quantity--;
                }
            }
        }
        this.setState({ allItems: arr });
    };

    clearCart = () => {
        let arr = this.state.allItems.slice();
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].quantity > 0) {
                arr[i].quantity = 0;
            }
        }
        this.setState({ allItems: arr });
    };

    changeBidIncluded = (isIncluded) => {
        // console.log('changeBidIncluded called, isIncluded: ', isIncluded);
        if (!isIncluded) {
            this.setState({ includeBidItems: false });
        }
        else {
            this.setState({ includeBidItems: true });
        }
    };

    updateItemCount = (itemNo, number) => {
        let newCart = [];
        let item = '';
        // Insert a list of all available items into newCart
        this.state.allItems.map((item) => newCart.push(
            {
                itemNo: item.itemNo,
                quantity: item.quantity,
                hebDescription: item.hebDescription,
                engDescription: item.engDescription,
                hebName: item.hebName,
                engName: item.engName,
                picDescription: item.picDescription,
                picFile: item.picFile,
                priceNis: item.priceNis,
                priceUsd: item.priceUsd,
                category: item.category
            }
        ));
        // Loop through newCart, when the matching item is found, update the quantity
        for (let i = 0; i < newCart.length; i++) {
            if (newCart[i].itemNo === itemNo) {
                newCart[i].quantity += number; //(1 / -1)
                item = newCart[i];
            }
        }
        if (item !== '') {
            if (number > 0) {
                this.addToCart(item);
            }
            else if (number < 0) {
                this.removeFromCart(itemNo);
            }
        }
        this.setState({ allItems: newCart });
    }

    getSelectedCategory = async (category) => {
        this.setState({ selectedCategory: category });
    }

    selectedCategoryChanged = async (category) => {
        this.setState({ items: this.state.allItems, selectedCategory: category });
    }

    changeLanguage = async (language) => {
        // Languages: hebrew, english
        //console.log('language: ', language);
        if (language === 'hebrew' || language === 'english') {
            this.setState({ language: language });
        }
    };

    changeCurrency = async (currency) => {
        // Currencies: ILS, USD
        //console.log('currency: ', currency);
        if (currency === 'ILS' || currency === 'USD') {
            this.setState({ currency: currency });
        }
    };

    getAvailablePayments = async () => {
        // let lang = this.state.language;
        // let pageNo = 1;
        // const response = await shelegApi.get(`/LandingPage/${this.state.sessionId}/${pageNo}`);
        // console.log('LandingPage: ', response.data);
        // let arr = [];
        // arr.push({cityCode: '0', cityName: langConf[lang].selectCity});
        // //console.log('cities: ', response.data);
        // response.data.map((city) => arr.push(
        //     {
        //         cityCode: city.cityCode,
        //         cityName: city.cityName
        //     }
        // ));
        // this.setState({ cities: arr }); 
    };

    saveNewCart = async () => {
        let lang = this.state.language;
        let newCartItems = [];
        let oldCartNo = 0;
        for (let i = 0; i < this.state.finalOfferItems.length; i++) {
            if (this.state.finalOfferItems[i].cartNo !== 0) {
                oldCartNo = this.state.finalOfferItems[i].cartNo;
            }
        }

        this.state.finalOfferItems.map((item) => newCartItems.push(
            {
                cartNo: item.cartNo === 0 ? oldCartNo : item.cartNo,
                cartItemDate: item.cartItemDate,
                itemNo: item.itemNo,
                itemDescription: lang === 'hebrew' ? item.hebName : item.engName,
                price: this.state.currency === 'ILS' ? item.priceNis : item.priceUsd,
                currency: this.state.currency === 'ILS' ? 9999 : 1,
                quantity: item.quantity,
                recKey: item.recKey,
                runningLineNo: item.runningLineNo
            }
        ));
        //console.log('newCartItems: ', newCartItems);
        let response = await sheleg.post(`ClearingPage/${this.state.slgCustId}/PostInvoice/${this.state.objType}/${this.state.objNo}`, newCartItems);
        //console.log('post invoice response: ', response);
        //console.log('post invoice response.data: ', response.data);
        await this.changeInvNo(response.data);
    };

    changeScreen = async (screen) => {
        // Screens: items, cart, finalOffer, payment, transactionResult
        if (screen === 'signup' || screen === 'login' || screen === 'items' || screen === 'cart' || screen === 'finalOffer' || screen === 'payment' || screen === 'transactionResult' || screen === 'forgotPassword') {
            this.setState({ screen: screen });
        }
    };

    changeTransactionResult = async (result) => {
        // Results: error, success, failure
        if (result === 'error' || result === 'success' || result === 'failure') {
            this.setState({ transactionResult: result });
        }
    };

    changeExistingUsername = async (username) => {
        this.setState({ existingUsername: username });
    };

    changeSelectedCity = async (city) => {
        this.setState({ selectedCity: city });
    };

    changeSelectedCityName = async (cityName) => {
        this.setState({ selectedCityName: cityName });
    };

    changeSelectedStreet = async (street) => {
        this.setState({ selectedStreet: street });
    };

    changeSelectedStreetName = async (streetName) => {
        this.setState({ selectedStreetName: streetName });
    };

    changeVatIncluded = async (included) => {
        // Results: true, false
        //console.log('price include vat: ', included);
        if (included === true || included === false) {
            this.setState({ priceIncludeVat: included })
        }
    };

    changeObjectType = async (objType) => {
        this.setState({ objType: objType });
    };



    changeObjectNo = async (objectNo) => {
        this.setState({ objNo: objectNo });
    };

    changeInvNo = async (invNo) => {
        this.setState({ invNo: invNo });
    };

    changePaymentMode = (mode) => {
        if (mode === 'payment' || mode === 'login' || mode === 'signup' || mode === 'forgotPassword') {
            this.setState({ paymentMode: mode });
        }
    };

    changeMultiplePayments = (multiplePayments) => {
        if (multiplePayments === true || multiplePayments === false) {
            this.setState({ multiplePayments: multiplePayments })
        }
    };

    toFinalOffer = (event) => {
        event.preventDefault();
        let d = new Date();
        let offer = [];
        let arr = this.state.allItems.slice();
        if (this.state.includeBidItems) {
            for (let i = 0; i < this.state.bidItems.length; i++) {
                arr.push(
                    {
                        category: 999,
                        engDescription: '',
                        engName: this.state.bidItems[i].itemDescription,
                        hebDescription: '',
                        hebName: this.state.bidItems[i].itemDescription,
                        itemNo: this.state.bidItems[i].itemNo,
                        picDescription: '',
                        picFile: '',
                        priceNis: this.state.bidItems[i].priceNis,
                        priceUsd: this.state.bidItems[i].priceUsd,
                        quantity: this.state.bidItems[i].quantity,
                        cartNo: this.state.bidItems[i].cartNo,
                        recKey: this.state.bidItems[i].recKey,
                        runningLineNo: this.state.bidItems[i].runningLineNo,
                        cartItemDate: this.NormalizeDate(d.getDate(), d.getMonth(), d.getFullYear()) //this.state.bidItems[i].cartItemDate
                    }
                );
            }
        }
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].quantity > 0) {
                offer.push(arr[i]);
            }
        }
        this.setState({
            finalOfferItems: offer,
            screen: 'finalOffer'
        });
    };

    toPayment = (event) => {
        event.preventDefault();
    };

    logoClick = (event) => {
        event.preventDefault();
    }

    isFinalOfferEnabled() {
        let counter = 0;
        for (let i = 0; i < this.state.allItems.length; i++) {
            if (this.state.allItems[i].quantity > 0) {
                counter += this.state.allItems[i].quantity;
            }
        }
        if (counter > 0) {
            return '';
        }
        else if (this.state.includeBidItems && this.state.bidItems.length > 0) {
            return '';
        }
        return 'disabled';
    }

    render() {
        let lang = this.state.language;
        let dir = langConf[lang].dir;
        let currURL = this.state.currentURL;
        let isDisabled = this.isFinalOfferEnabled();
        
        if (this.state.screen === 'login') {
            return (
                <ErrorBoundary>
                    <Login
                        //Globals
                        lang={lang}
                        currentURL={currURL}
                        vendorData={this.state.vendorData}
                        slgCustId={this.state.slgCustId}
                        sessionId={this.state.sessionId}
                        //Methods
                        changeLanguage={this.changeLanguage}
                        changeScreen={this.changeScreen}
                        changeObjectNo={this.changeObjectNo}
                        changeObjectType={this.changeObjectType}
                    />
                </ErrorBoundary>
            );
        }
        else if (this.state.screen === 'forgotPassword') {
            return (
                <ForgotPassword
                    //Globals
                    lang={lang}
                    currentURL={currURL}
                    vendorData={this.state.vendorData}
                    //Methods
                    changeLanguage={this.changeLanguage}
                    changeScreen={this.changeScreen}
                />
            );
        }
        else if (this.state.screen === 'signup') {
            return (
                <Signup
                    //Globals
                    lang={lang}
                    currentURL={currURL}
                    vendorData={this.state.vendorData}
                    sessionId={this.state.sessionId}
                    cities={this.state.cities}
                    selectedCity={this.state.selectedCity}
                    streets={this.state.streets}
                    selectedStreet={this.state.selectedStreet}
                    //Methods
                    changeLanguage={this.changeLanguage}
                    changeScreen={this.changeScreen}
                    changeSelectedCity={this.changeSelectedCity}
                    getStreets={this.getStreets}
                    changeExistingUsername={this.changeExistingUsername}
                />
            );
        }
        else if (this.state.screen === 'items') {
            return (
                <div dir={dir} >
                    <div id="pageHead" className={`page-head ${lang === 'hebrew' ? 'hebrew' : 'english'}`}>
                        <TopMenu
                            //Globals
                            lang={lang}
                            currency={this.state.currency}
                            currentURL={currURL}
                            vendorData={this.state.vendorData}
                            //Variables
                            allItems={this.state.allItems}
                            bidItems={this.state.bidItems}
                            includeBidItems={this.state.includeBidItems}
                            defaultVal={' '}
                            //Methods
                            changeLanguage={this.changeLanguage}
                            changeCurrency={this.changeCurrency}
                            changeScreen={this.changeScreen}
                            changeCategoriesVisibility={this.changeCategoriesVisibility}
                        />
                    </div>
                    <div className="col-3 col-xs-0"></div>
                    <div id="pageContent" className={`page-content ${lang === 'hebrew' ? 'hebrew' : 'english'} `} >
                        <ItemList
                            //Globals
                            lang={lang}
                            currency={this.state.currency}
                            currentURL={currURL}
                            vendorData={this.state.vendorData}
                            //Variables
                            allItems={this.state.allItems}
                            selectedCategory={this.state.selectedCategory}
                            //Methods
                            addToCart={this.addToCart}
                            removeFromCart={this.removeFromCart}
                            changeScreen={this.changeScreen}
                        />
                    </div>
                    <div className="col-3 col-xs-0"></div>
                </div>
            );
        } else if (this.state.screen === 'cart') {
            return (
                <div dir={dir}>
                    <TopMenu
                        //Globals
                        lang={lang}
                        currency={this.state.currency}
                        currentURL={currURL}
                        vendorData={this.state.vendorData}
                        //Variables
                        allItems={this.state.allItems}
                        bidItems={this.state.bidItems}
                        includeBidItems={this.state.includeBidItems}
                        defaultVal={' '}
                        //Methods
                        changeLanguage={this.changeLanguage}
                        changeCurrency={this.changeCurrency}
                        changeScreen={this.changeScreen}
                        changeCategoriesVisibility={this.changeCategoriesVisibility}
                    />
                    <div id="pageContent" className={`page-content ${lang === 'hebrew' ? 'hebrew' : 'english'} col-12 col-xs-12`} style={{}} >

                        <BidItems
                            //Globals
                            lang={lang}
                            currency={this.state.currency}
                            //Variables
                            bidItems={this.state.bidItems}
                            includeBidItems={this.state.includeBidItems}
                            //TODO: Add quantity buttons
                            //Methods
                            changeBidIncluded={this.changeBidIncluded}
                        />

                        <CartItems
                            //Globals
                            lang={lang}
                            currency={this.state.currency}
                            //Variables
                            allItems={this.state.allItems}
                            //Methods
                            updateItemCount={this.updateItemCount}
                            addToCart={this.addToCart}
                            removeFromCart={this.removeFromCart}
                        />
                        <div className={`col-6`} style={lang === 'hebrew' ? { float: 'right', marginTop: '5px' } : { float: 'left', marginTop: '5px' }}>
                            <BackButton
                                //Globals
                                lang={lang}
                                currentURL={currURL}
                                //Methods
                                onClick={(event) => { event.preventDefault(); this.changeScreen('items') }}
                            />
                        </div>
                        <div className={`col-6`} style={lang === 'hebrew' ? { float: 'left', marginTop: '5px' } : { float: 'right', marginTop: '5px' }}>
                            <a href={currURL} className={`btn btn-success btn-lg btn-block ${isDisabled} `} onClick={this.toFinalOffer} >{langConf[lang].toFinalOffer}</a>
                        </div>
                    </div>
                </div>
            );
        }
        else if (this.state.screen === 'finalOffer') {
            return (
                <div>
                    <TopMenu
                        //Globals
                        lang={lang}
                        currency={this.state.currency}
                        currentURL={currURL}
                        vendorData={this.state.vendorData}
                        //Variables
                        allItems={this.state.allItems}
                        bidItems={this.state.bidItems}
                        includeBidItems={this.state.includeBidItems}
                        defaultVal={' '}
                        //Methods
                        changeLanguage={this.changeLanguage}
                        changeCurrency={this.changeCurrency}
                        changeScreen={this.changeScreen}
                        changeCategoriesVisibility={this.changeCategoriesVisibility}
                    />
                    <div className="col-3 col-xs-0"></div>
                    <div id="pageContent" className={`page-content ${lang === 'hebrew' ? 'hebrew' : 'english'} col-12 col-xs-12`} style={{}} >
                        <FinalOffer
                            //Globals
                            lang={lang}
                            currency={this.state.currency}
                            currentURL={currURL}
                            //Variables
                            slgCustId={this.state.slgCustId}
                            objNo={this.state.objNo}
                            finalOfferItems={this.state.finalOfferItems}
                            //Methods
                            changeScreen={this.changeScreen}
                            changeInvNo={this.changeInvNo}
                        />
                    </div>
                    <div className="col-3 col-xs-0"></div>
                </div>
            );
        }
        else if (this.state.screen === 'payment') {
            return (
                <div>
                    <TopMenu
                        //Globals
                        lang={lang}
                        currency={this.state.currency}
                        currentURL={currURL}
                        vendorData={this.state.vendorData}
                        //Variables
                        allItems={this.state.allItems}
                        bidItems={this.state.bidItems}
                        includeBidItems={this.state.includeBidItems}
                        defaultVal={' '}
                        //Methods
                        changeLanguage={this.changeLanguage}
                        changeCurrency={this.changeCurrency}
                        changeScreen={this.changeScreen}
                        changeCategoriesVisibility={this.changeCategoriesVisibility}
                    />
                    <div id="pageContent" className={`page-content ${lang === 'hebrew' ? 'hebrew' : 'english'}`} style={{}} >
                        <ErrorBoundary>
                            <Payment
                                //Globals
                                lang={lang}
                                currency={this.state.currency}
                                currentURL={currURL}
                                slgCustId={this.state.slgCustId}
                                objNo={this.state.objNo}
                                objType={this.state.objType}
                                vatIncluded={this.state.pricesIncludeVat}
                                sessionId={this.state.sessionId}
                                vendorData={this.state.vendorData}
                                //Variables
                                finalOfferItems={this.state.finalOfferItems}
                                invNo={this.state.invNo}
                                transactionResult={this.state.transactionResult}
                                cities={this.state.cities}
                                selectedCity={this.state.selectedCity}
                                selectedCityName={this.state.selectedCityName}
                                streets={this.state.streets}
                                selectedStreet={this.state.selectedStreet}
                                selectedStreetName={this.state.selectedStreetName}
                                paymentMode={this.state.paymentMode}
                                availablePayments={this.state.availablePayments}
                                multiplePayments={this.state.multiplePayments}
                                existingUsername={this.state.existingUsername}
                                //TODO: Inform user of transaction success/ failure
                                //Methods
                                changeScreen={this.changeScreen}
                                changeSelectedCity={this.changeSelectedCity}
                                changeSelectedCityName={this.changeSelectedCityName}
                                changeSelectedStreet={this.changeSelectedStreet}
                                changeSelectedStreetName={this.changeSelectedStreetName}
                                changeTransactionResult={this.changeTransactionResult}
                                changePaymentMode={this.changePaymentMode}
                                getStreets={this.getStreets}
                                changeInvNo={this.changeInvNo}
                                clearCart={this.clearCart}
                                changeLanguage={this.changeLanguage}
                                changeObjectNo={this.changeObjectNo}
                                changeObjectType={this.changeObjectType}
                                changeMultiplePayments={this.changeMultiplePayments}
                                saveNewCart={this.saveNewCart}
                                changeExistingUsername={this.changeExistingUsername}
                            />
                        </ErrorBoundary>
                    </div>
                </div>
            );
        }
        else {
            return (
                <div>
                    <TransactionResult
                        //Globals
                        lang={lang}
                        currentURL={currURL}
                        vendorData={this.state.vendorData}
                        //Variables
                        transactionResult={this.state.transactionResult}
                        //Methods
                        changeScreen={this.changeScreen}
                    />
                </div>
            );
        }
    }
}

export const history = createBrowserHistory({
    basename: process.env.PUBLIC_URL
});

export default App;